angular.module('omfm').controller('saoCompaniesCtrl', SaoCompaniesController);

SaoCompaniesController.$inject = ['$scope', '$rootScope', '$timeout', '$location', 'SaoCompany', 'Message', 'SaoClient', 'uiSimpleModal'];

function SaoCompaniesController($scope, $rootScope, $timeout, $location, SaoCompany, Message, SaoClient, uiSimpleModal) {
	function getCampaigns(clientId){
		SaoClient.campaigns({id: clientId}, function(campaigns){
			$scope.campaigns = campaigns;

			$timeout(function(){
				jQuery('#campaignId').select2({
					placeholder: "Select campaign for list",
				});
			}, 80);
		});
	}

	$scope.getClients = function(){
		SaoClient.list({}, function(result){
			$scope.clients = result;

			if($scope.filters.client_id) {
				$timeout(function(){
					jQuery("#clientsFilter").val($scope.filters.client_id);
					$scope.selectClient();
				}, 0);

				getCampaigns($scope.filters.client_id);
			}

			$timeout(function(){
				jQuery('#clientsFilter').select2({
					placeholder: "Select account",
				});
			}, 80);

		})
	};

	$scope.selectClient = function () {
		let client = $scope.clients.filter(function(i){
			return i.id == $scope.filters.client_id;
		})[0];

		if(!client){
			return;
		}

		$scope.selectedClient = client;
		$location.search('filters', angular.toJson($scope.filters));

		getCampaigns(client.id);

		if(client.contacts_lists && client.contacts_lists.length === 1) {
			$scope.selectList(client.contacts_lists[0]);
		} else if($scope.filters.list_id) {
			$scope.selectList();
		}
	};

	$scope.selectList = function(list){
		if(!list) {
			list = $scope.selectedClient.contacts_lists.filter(function(i){
				return i.id == $scope.filters.list_id;
			})[0];

			if(!list){
				return;
			}
		}

		$scope.selectedList     = list;
		$rootScope.selectedList = list;

		$timeout(function(){
			jQuery('#campaignId').val(list.campaign_id);
		}, 400);

		$scope.filters.list_id = list.id;
		$location.search('filters', angular.toJson($scope.filters));
		$rootScope.$broadcast('sao:selectedList', $scope.selectedList);

		$scope.getCompaniesList();
	};

	$scope.saveCampaign = function(){
		SaoClient.saveCampaign({
			list_id: $scope.selectedList.id,
			campaign_id: $scope.selectedList.campaign_id
		});

		$rootScope.$broadcast('sao:selectedList', $scope.selectedList);
	};

	$scope.createList = function(){
		uiSimpleModal({
			title:       'Create new list',
			templateUrl: '/app/omfm/templates/newListModal.html',
			size: '',
			showTitleClose: true,
			data :{},
			returnData: true,
			buttons: ['ok', 'cancel']
		}).then(function(data){
			if(data.button !== 'ok'){
				return;
			}

			if(!data.data.list_name){
				return;
			}

			SaoClient.createList({
				id: $scope.selectedClient.id,
				client_id: $scope.selectedClient.id,
				list_name: data.data.list_name
			}, function(list){
				$scope.selectedClient.contacts_lists.push(list);
				$scope.selectList(list);
			});

		}, function(){
			// Need to avoid errors in console
		});
	};

	$scope.deleteList = function (list, $index, $event) {
		$event.preventDefault();
		$event.stopPropagation();

		uiSimpleModal({
			title: 'Delete list',
			text: 'Are you sure want to delete list ' + list.list_name,
			size: '',
			showTitleClose: true,
			buttons: ['ok', 'cancel']
		}).then(function(button){
			if(button !== 'ok'){
				return;
			}

			SaoClient.deleteList({
				id: $scope.selectedClient.id,
				client_id: $scope.selectedClient.id,
				list_id: list.id
			}, function(list){
				$scope.selectedClient.contacts_lists.splice($index, 1);
				$scope.selectedList = undefined;
			});

		}, function(){
			// Need to avoid errors in console
		});
	};

	$scope.getCompaniesList = function(){
		SaoCompany.list({list_id: $scope.selectedList.id}, function(data){
			$scope.companies = data;
		})
	};

	$scope.rowClass = function(c){
		let cssClass = '';

		if(c.isActive){
			cssClass += ' table-primary';
		}

		if(c.edited){
			cssClass += ' edited';
		}

		return cssClass;
	};

	$scope.addContact = function () {
		uiSimpleModal({
			title:       'Add new contact',
			templateUrl: '/app/omfm/templates/saoAddContactModal.html',
			size: '',
			showTitleClose: true,
			data: {},
			backdrop: 'static',
			returnData: true,
			buttons: ['ok', 'cancel']
		}).then(function(data){
			if(data.button !== 'ok'){
				return;
			}

			let newContactData = data.data;
			newContactData.list_id    = $scope.selectedList.id;

			SaoClient.importContact(newContactData, function(contact){
				Message.pushSuccess('Contact added!');
				$scope.getCompaniesList();
			});

		}, function(){
			// Need to avoid errors in console
		});
	};

	$scope.editLetters = function(company, $index){
		if(company.id === 0) {

			if($scope.selectedList){
				let save = function(letters, companyEdited, callback){
					SaoClient.saveListTemplates({
						letters: letters,
					}, function(){

						if(typeof callback == "function"){
							callback()
						}

						let successMessage = "Letters for list " + $scope.selectedList.list_name + ' saved!';
						Message.pushSuccess(successMessage);
					});
				};

				SaoClient.listTemplates({id: $scope.selectedList.id}, function(cData){
					let title = 'Editing messages for list ' + $scope.selectedList.list_name;

					let data = {
						title: title,
						type: 'list',
						list: $scope.selectedList,
						letters: cData.letters,
						nextIndex: $index + 1,
						prevIndex: $index - 1,
						save: save
					};

					if($scope.companies){
						$scope.companies = $scope.companies.map(function(c){
							c.isActive = false;

							return c;
						});
					}

					company.isActive = true;

					$rootScope.$broadcast('sao:editLetters', data);
				});

				return;
			}

			let save = function(letters, companyEdited, callback){
				SaoClient.saveGeneralTemplates({
					letters: letters,
				}, function(){

					if(typeof callback == "function"){
						callback()
					}

					let successMessage = "General templates saved!";
					Message.pushSuccess(successMessage);
				});
			};

			SaoClient.generalTemplates({}, function(cData){
				let title = 'Editing general templates';

				let data = {
					title: title,
					type: 'company',
					letters: cData.letters,
					nextIndex: $index + 1,
					prevIndex: $index - 1,
					save: save
				};

				if($scope.companies){
					$scope.companies = $scope.companies.map(function(c){
						c.isActive = false;

						return c;
					});
				}

				company.isActive = true;

				$rootScope.$broadcast('sao:editLetters', data);
			});

			return;
		}

		let save = function(letters, companyEdited, callback){
			SaoCompany.save({
				id: company.id,
				company: companyEdited,
				company_id: company.id,
				letters: letters,
				mark_as_edited: typeof callback == "function"
			}, function(){

				if(typeof callback == "function"){
					callback()
				}

				let successMessage =  "Letters for company " + company.url + ' saved!';
				Message.pushSuccess(successMessage);
			});
		};

		SaoCompany.letters({id: company.id}, function(cData){
			let title = 'Editing messages for company ' + company.url;

			let data = {
				title: title,
				type: 'company',
				company: company,
				list: $scope.selectedList,
				url:  company.url,
				letters: cData.letters,
				nextIndex: $index + 1,
				prevIndex: $index - 1,
				save: save
			};

			$scope.companies = $scope.companies.map(function(c){
				c.isActive = false;

				return c;
			});

			company.isActive = true;

			$rootScope.$broadcast('sao:editLetters', data);
		});
	};

	$scope.$on('sao:editLetters:byIndex', function(event, data) {
		if(data.type !== 'company'){
			return;
		}

		let index = data.index;

		if(index < 0 || index > $scope.companies.length){
			return;
		}

		let company = $scope.companies[data.index];

		if(!company) {
			return;
		}

		$scope.editLetters(company, index);
	});

	$scope.$on('sao:lettersEditorClosed', function(event, data) {
		if(data.type !== 'company') {
			return;
		}

		for (let i = 0; i < $scope.companies.length; i++) {
			$scope.companies[i].isActive = false;
		}

	});

	$scope.search = '';

	$scope.filters = angular.fromJson($location.search().filters) || {
		list_id: '',
		client_id: ''
	};

	$scope.getClients();
}